// Fallback shown by the AI Early-Payment modal when the transcript did not match any installment.
import { X, AlertTriangle } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function EarlyPaymentAINoMatch({ statedName, candidates, onClose }) {
  const { t } = useI18n();
  return (
    <div data-testid="early-ai-notfound" className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-md grid place-items-center p-4">
      <div className="w-full max-w-sm neu rounded-3xl p-5 space-y-3 text-center">
        <button onClick={onClose} className="absolute p-1.5 rounded-lg text-slate-500"><X className="w-4 h-4" /></button>
        <AlertTriangle className="w-10 h-10 text-amber-500 mx-auto" />
        <p className="font-bold">{t("noMatchTitle")}</p>
        <p className="text-xs text-slate-600">{t("noMatchBody")} <b>&quot;{statedName}&quot;</b></p>
        {candidates?.length > 0 && <p className="text-[11px] text-slate-500">{t("didYouMean")}: {candidates.join(" · ")}</p>}
        <button onClick={onClose} className="w-full py-2 rounded-2xl neu-fill-blue text-white font-semibold">{t("ok")}</button>
      </div>
    </div>
  );
}
